import { createBaseEndpoints, Service } from '../Service'
import { kebabize, removeFromString } from '@/utils/objects'

const ENDPOINTS = createBaseEndpoints('CompanyDetails')

class ModuleService extends Service {
  async checkExistNotMoreThanOne ({ companyID, field, detailID }) {
    const params = {
      select: `id,${field}`,
      filter: `companyID=="${companyID}"&&${field}!=null`,
      count: true
    }
    const { data: { count, value } } = await this.getAllDynamic(params)
    if (count === 0 || (count === 1 && value.some(({ id }) => id === detailID))) {
      return { data: { count, value } }
    } else {
      throw new Error(`not-allow-more-then-one-${kebabize(removeFromString(field, 'ID'))}`)
    }
  }
}

export const ServiceCompanyDetail = new ModuleService({
  ...ENDPOINTS
})
